import React from 'react';
import { Button, Grid, Typography } from '@mui/material';

function FilterGroupTwo({ data }) {

    React.useEffect(() => {
        // Adicionar um ouvinte de evento para o redimensionamento da janela
        window.addEventListener('resize', data.atualizarTamanhoDaTela());
        // Chamar a função inicialmente para pegar o tamanho da tela no início
        data.atualizarTamanhoDaTela();
        // Remover o ouvinte de evento quando o componente for desmontado
        return () => {
            window.removeEventListener('resize', data.atualizarTamanhoDaTela());
        };
    }, []);
    

    return (
         <Grid>
            <Grid sx={{
                width: '90vw',
                display: 'flex',
                backgroundColor: '#FAFAFA',
                margin: '-20px 1px 0px -2px',
                padding: '5px 0px 20px 28px',
                alignItems: 'center'
            }}>
                {/* <Typography sx={{ color: '#FFF', paddingLeft: '25px', fontSize: '16px' }}>
                    Seleção:
                </Typography>
                <Typography sx={data.larguraDaTela < 1500 ? styles.filterResultLargura : styles.filterResult}>
                    {data.selectedDepartment == '' ? '' : data.selectedDepartment}
                </Typography>
                <Typography sx={data.larguraDaTela < 1500 ? styles.filterResultLargura : styles.filterResult}>
                    {data.employeeSelected == '' ? 'TODOS OS COLABORADORES' : employeeSelected}
                </Typography>
                {/* <Typography sx={larguraDaTela < 1500 ? styles.filterResultLargura : styles.filterResult}>
                    DE 1  ATÉ {data.selectPeriod.endDate} DE {data.selectPeriod.name}
                </Typography> */}
            </Grid>
        </Grid>
    )
}

export default FilterGroupTwo;

const styles = ({
    filterResult: {
        color: '#FFF',
        paddingLeft: '25px',
        fontSize: '25px'
    },
    filterResultLargura: {
        color: '#FFF',
        paddingLeft: '25px',
        fontSize: '18px'
    },
    filterAlphabet: {
        paddingLeft: '25,px',
        fontSize: '16px'
    },
    filterAlphabetLargura: {
        paddingLeft: '10px',
        fontSize: '16px'
    }

})